<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="fm_split"><span class="right_1" epub:type="pagebreak" id="page_iii" title="iii"><span class="make_smallcaps"><b>I USED TO THINK OUR MEMORIES BELONG TO US.</b></span> Now I don’t think they’re that cooperative. They interrupt when they please, and leave right when you want to hold them in your hands and arrange them on a shelf, so they tell the story you think they should. They haunt you or comfort you at will. But when memories are all you have left of a person, you’ll take them thin as the tail of a cloud or so thick you’re lost in them for hours. Just don’t ever assume you have memories; your memories definitely have you.</span></p>
<p class="indent">In my mind’s eye, I watch the one of me leaving my Scofield Dinner Theater job that day in August right before the start of senior year, worrying about things that didn’t matter for shit, completely oblivious to the way my world was about to detonate. Shouldn’t I want to be that version of me again? Obviously the correct answer is yes. The weird thing is, I don’t think I do.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062932099_Frontmatter.vue?0e1375a8